import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';
import { catchError, interval, of, switchMap } from 'rxjs';

const UPDATE_CHECK_INTERVAL_MS = 5 * 60 * 1000;

@Injectable({
  providedIn: 'root',
})
export class AppUpdateService {
  private readonly http = inject(HttpClient);
  private readonly destroyRef = inject(DestroyRef);

  readonly showNewVersionButton = signal(false);

  private loadedIndexHtml: string | null = null;

  checkForUpdates(): void {
    this.fetchIndexHtml()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(html => {
        this.loadedIndexHtml = html;
      });

    interval(UPDATE_CHECK_INTERVAL_MS)
      .pipe(
        switchMap(() => this.fetchIndexHtml()),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(html => {
        if (
          html !== null &&
          this.loadedIndexHtml !== null &&
          html !== this.loadedIndexHtml
        ) {
          this.showNewVersionButton.set(true);
        }
      });
  }

  private fetchIndexHtml() {
    return this.http
      .get(`/index.html?_=${Date.now()}`, { responseType: 'text' })
      .pipe(catchError(() => of(null)));
  }
}
